<!-- <p>hierarchy-manage-location works!</p> -->
<ejs-tab id="element" *ngIf="selectedLocation">
	<e-tabitems>
		<e-tabitem>
			<ng-template #headerText>
				<span class="app-icon app-icon--analytics"><mat-icon />&nbsp;Properties</span>
			</ng-template>
			<ng-template #content>
				<ng-container *ngTemplateOutlet="propertiesTab"></ng-container>
			</ng-template>
		</e-tabitem>
		<e-tabitem>
			<ng-template #headerText>
				<span class="app-icon app-icon--lock"><mat-icon />&nbsp;Permissions</span>
			</ng-template>
			<ng-template #content>
				<ng-container *ngTemplateOutlet="permissionsTab"></ng-container>
			</ng-template>
		</e-tabitem>
		<e-tabitem>
			<ng-template #headerText>
				<span class="app-icon app-icon--sublocation"><mat-icon />&nbsp;Sublocations</span>
			</ng-template>
			<ng-template #content>
				<ng-container *ngTemplateOutlet="subLocationsTab"></ng-container>
			</ng-template>
		</e-tabitem>
		<e-tabitem>
			<ng-template #headerText>
				<span class="app-icon app-icon--asset"><mat-icon />&nbsp;Assets</span>
			</ng-template>
			<ng-template #content>
				<ng-container *ngTemplateOutlet="assetsTab"></ng-container>
			</ng-template>
		</e-tabitem>
	</e-tabitems>
</ejs-tab>

<ng-template #tabHeading let-showMenu="showMenu">
	<div style="display: flex;" class="location-title alignRow" *ngIf="selectedLocation">
		<mat-icon *ngIf="!selectedLocation.ParentUid" style="padding: 0px; margin-right: 0.5em;">factory</mat-icon>
		<mat-icon *ngIf="selectedLocation.ParentUid" style="padding: 0px; margin-right: 0.5em;">folder</mat-icon>
		<span *ngIf="!selectedLocation.ParentUid">Site: {{selectedLocation.Name}}</span>
		<span *ngIf="selectedLocation.ParentUid">Location:{{selectedLocation.Name}}</span>
		<span *ngIf="!!selectedLocation.FunctionalLocation">&nbsp;({{selectedLocation.FunctionalLocation}})</span>
		<mat-icon *ngIf="selectedLocation.Hidden" style="margin-left: 10px;"
			matTooltip="This Location is Hidden">visibility_off</mat-icon>
		<span class="toolbar-spacer"></span>
		<button *ngIf="!selectedLocation.Hidden" mat-raised-button color="primary" style="margin-right: 9px;" class="app-icon--goto"
			(click)="goToLocation()">
			<span>Go To Asset</span>
			<mat-icon/>
		</button>
		<div class="toolbar-buttons alignRow" *ngIf="showMenu && selectedLocation">
			<span class="app-icon app-icon--add-asset" (click)="addAsset(selectedLocation)" *ngIf="selectedLocation"
				matTooltip="Add Asset">
				<mat-icon />
			</span>
			<span class="app-icon app-icon--add-location" (click)="addLocation(selectedLocation)"
				*ngIf="selectedLocation" matTooltip="Add Location">
				<mat-icon />
			</span>
			<span (click)="toggleHidden()" *ngIf="selectedLocation" style="margin: 0.5em !important;" class="alignRow">
				<mat-icon *ngIf="!selectedLocation.Hidden" matTooltip="Hide Location">visibility_off</mat-icon>
				<mat-icon *ngIf="selectedLocation.Hidden" matTooltip="Unhide Location">visibility</mat-icon>
			</span>
			<span class="app-icon app-icon--delete" (click)="deleteListLocation(selectedLocation)"
				*ngIf="selectedLocation" matTooltip="Delete Location"><mat-icon /></span>
		</div>
	</div>
	<hr style="min-width: 56vw;">
</ng-template>

<ng-template #propertiesTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:true}"></ng-container>
	<div class=" content-body">
		<form [formGroup]="locationForm">
			<div *ngIf="error" class="alert alert-danger">{{error}}</div>
			<div *ngIf="success" class="alert alert-success">{{success}}</div>
			<mat-form-field appearance="fill">
				<mat-label>Location Name</mat-label>
				<input matInput autocomplete="off" readonly formControlName="Name" autocomplete="off">
			</mat-form-field>
			<mat-form-field appearance="fill">
				<mat-label>Location Description</mat-label>
				<input matInput autocomplete="off" readonly formControlName="Description" autocomplete="off">
			</mat-form-field>
			<mat-form-field appearance="fill">
				@let Location = locationForm.get('FunctionLocation')?.value;
				<mat-label>Functional Location
					<small *ngIf="!Location" class="inherited">Inherited</small>
				</mat-label>
				@if (Location) {<input matInput autocomplete="off" readonly formControlName="FunctionLocation">}
				@else {<input matInput autocomplete="off" readonly formControlName="ParentFunctionalLocation">}
			</mat-form-field>

			@if (selectedLocation) {
			@let imgTitle = selectedLocation.Name + " - " +selectedLocation.LocationType;
			@let imgURL = (!selectedLocation.ParentUid
			? imagePathOrganisations()
			: imagePathSubLocations()) + selectedLocation.Id+"?"+selectedLocation.Modified;
			<div class="properties-image-container">
				<img class="properties-tab-image" (click)="viewImage(imgURL)" [src]="imgURL" [title]="imgTitle"
					onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
					[attr.x-contenttype]="'image/png'" />
			</div>
			}
			<button mat-button type="button" *ngIf="selectedLocation.ParentUid" (click)="editLocation()"
				style="border-radius: 1em; border: 2px solid;margin-left: auto;margin-right: 1em;">
				Edit Location
			</button>
		</form>
	</div>
</ng-template>

<ng-template #permissionsTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:false}"></ng-container>
	<nav class="location-title">
		<span>Permission Groups: </span>
		<span class="toolbar-spacer"></span>
	</nav>
	<div class="content-body">
		<span>
			<div class="mat-elevation-z4 groups-container ">
				<div class="alignRow" style="margin-bottom: 10px;">
					<span class="app-icon app-icon--groups"><mat-icon style="margin-right: 1em;" /></span>
					<span>Groups</span>
					<span class="me-auto"></span>
					<span class="app-icon app-icon--add"><mat-icon title="Add Group" (click)="addNewGroup()" /></span>
				</div>
				<ejs-listbox [dataSource]='selectedGroups' [fields]="permissionsFields" sortOrder="Ascending"
					style="border: 1; border-color: lightgray; border-width: 1px; border-style: solid;border-radius: 10px;">
					<ng-template #itemTemplate let-data>
						<span class="alignRow" (click)="selectGroup(data)"
							[ngStyle]="{'color': data.Inherited ? 'lightgrey' : 'inherit'}">
							<mat-icon style="margin-right: 1em;">group</mat-icon>
							<span>{{data.Name}}</span>
							<span class="me-auto"></span>
							<span *ngIf="!data.Inherited" class="app-icon app-icon--edit alignRow"
								(click)="editGroup(data)"><mat-icon /></span>
							<span *ngIf="!data.Inherited" class="app-icon app-icon--delete alignRow"
								(click)="deleteGroup(data)"><mat-icon /></span>
						</span>
					</ng-template>
				</ejs-listbox>
			</div>
			<div class="mat-elevation-z4 permissions-container ">
				<div class="alignRow" style="margin-bottom: 10px;">
					<span>{{selectedGroup?.Name}}&nbsp;Permissions</span>
				</div>
				<ejs-listview [dataSource]='selectedGroup?.Permissions'
					style="border: 1; border-color: lightgray; border-width: 1px; border-style: solid;border-radius: 10px;">
					<ng-template #template let-data>
						<Span>View:<mat-checkbox [disabled]="true" [ngModel]="data.View" /></Span>
						<Span>Write:<mat-checkbox [disabled]="true" [ngModel]="data.Write" /></Span>
						<Span>Inherited:<mat-checkbox [disabled]="true" [ngModel]="data.Inherited" /></Span>
					</ng-template>
				</ejs-listview>
			</div>
		</span>
	</div>
</ng-template>

<ng-template #subLocationsTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:false}"></ng-container>
	<nav class="location-title">
		<span>SubLocations: </span>
		<span class="toolbar-spacer"></span>
		<span class="app-icon app-icon--add">
			<mat-icon style="float: right;" matTooltip="New SubLocation" (click)="addLocation(selectedLocation)" />
		</span>
		@if (selectedLocation.SubChild && selectedLocation.SubChild.length > 1) {
		<button mat-button class="app-icon " (click)="toggleReorderLocations()">
			<mat-icon matTooltip="Change Order">@if (reOrderLocations)
				{shuffle} @else {swap_vert}</mat-icon>
			@if (!reOrderLocations)
			{Change Order} @else {Save New Order}
		</button>
		}
	</nav>
	<div class="content-body" *ngIf="selectedLocation.SubChild">
		<div class="listview-container">
			@if (reOrderLocations){
			<nav style="display: flex;">
				<span class="toolbar-spacer"></span>
				<button mat-button class="app-icon " (click)="sortLocationsAlphabetical()">
					<mat-icon matTooltip="Sort Alphabetically">sort_by_alpha</mat-icon>
				</button>
			</nav>
			}
			<ejs-listbox #locationListbox [dataSource]='selectedLocation.SubChild' cssClass="e-list-template"
				(drop)="onLocationListBoxDrop($event)" [fields]="locationFields">
				<ng-template #itemTemplate let-dataSource>
					<div class="ejs-listview-item listview-location">
						@if (reOrderLocations) {
						<mat-icon matTooltip="Re order">swap_vert</mat-icon>
						<span class="parentOrder">&nbsp;{{dataSource.ParentOrder}}&nbsp;</span>
						}
						<img class="image"
							(click)="viewImage(imagePathSubLocations()+dataSource.Id+'?'+dataSource.Modified)"
							src="{{imagePathSubLocations()}}{{dataSource.Id}}?{{dataSource.Modified}}"
							*ngIf="selectedLocation" title="{{dataSource.Name}} - {{dataSource.LocationType}}"
							onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
							[attr.x-contenttype]="'image/png'" />
						<span class="detail"> {{dataSource.Name}}</span>
						<span class="detail"
							*ngIf="!!dataSource.FunctionalLocation">({{dataSource.FunctionalLocation}})</span>
						<span class="me-auto"></span>
						<div class="alignRow">
							<span class="app-icon app-icon--edit" style="margin: auto;">
								<mat-icon (click)="editListLocation(dataSource)" />
							</span>
							<span class="app-icon app-icon--delete" style="margin: auto;">
								<mat-icon (click)="deleteListLocation(dataSource)" />
							</span>
						</div>
					</div>
				</ng-template>
			</ejs-listbox>
		</div>
	</div>
	<div class="location-title" *ngIf="!selectedLocation.SubChild">This Location Has No SubLocations</div>
</ng-template>

<ng-template #assetsTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:false}"></ng-container>
	<nav class="location-title" style="display: flex;">
		<span>Assets: </span>
		<span class="toolbar-spacer"></span>
		<span class="app-icon app-icon--add"><mat-icon matTooltip="New Asset"
				(click)="addAsset(selectedLocation)" /></span>
		@if (selectedLocation.Assets && selectedLocation.Assets.length > 1) {
		<button mat-button class="app-icon " (click)="toggleReorderAssets()">
			<mat-icon matTooltip="ChangeOrder">@if (reOrderAssets)
				{shuffle} @else {swap_vert}</mat-icon>
			@if (!reOrderAssets)
			{Change Order} @else {Save New Order}
		</button>
		}
	</nav>
	<div class="content-body" *ngIf="selectedLocation.Assets">
		<div class="listview-container">
			@if (reOrderAssets){
			<nav style="display: flex;">
				<span class="toolbar-spacer"></span>
				<button mat-button class="app-icon " (click)="sortAssetsAlphabetical()">
					<mat-icon matTooltip="Sort Alphabetically">sort_by_alpha</mat-icon>
				</button>
			</nav>
			}
			<ejs-listbox #assetListbox [dataSource]='selectedLocation.Assets' cssClass="e-list-template"
				(drop)="onAssetListBoxDrop($event)" [fields]="assetFields">
				<ng-template #itemTemplate let-dataSource>
					<div class="detail" class="ejs-listview-item listview-asset">
						@if (reOrderAssets) {
						<mat-icon matTooltip="Re order">swap_vert</mat-icon>
						<span class="parentOrder">&nbsp;{{dataSource.ParentOrder}}&nbsp;</span>
						}
						<img class="image"
							(click)="viewImage(imagePathAssets()+dataSource.AssetID+'?'+dataSource.Modified)"
							src="{{imagePathAssets()}}{{dataSource.AssetID}}?{{dataSource.Modified}}"
							*ngIf="selectedLocation" title="{{dataSource.Name}} - {{dataSource.LocationType}}"
							onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
							[attr.x-contenttype]="'image/png'" />
						<span class="detail">{{dataSource.Name}}</span>
						<span class="detail"
							*ngIf="dataSource.Name != dataSource.Description && !!dataSource.Description">
							{{dataSource.Description}} </span>
						<span class="detail"
							*ngIf="dataSource.FunctionalLocation">({{dataSource.FunctionalLocation}})</span>
						<span class="me-auto"></span>
						<div class="alignRow">
							<span class="app-icon app-icon--edit" style="margin: auto;">
								<mat-icon (click)="editListAsset(dataSource)" />
							</span>
							<span class="app-icon app-icon--delete" style="margin: auto;">
								<mat-icon (click)="deleteListAsset(dataSource)" />
							</span>
						</div>
					</div>
				</ng-template>
			</ejs-listbox>
		</div>
	</div>
	<div class="location-title" *ngIf="!selectedLocation.Assets">This Location Has No Assets</div>
</ng-template>

<mat-menu #newEntry="matMenu" [overlapTrigger]="false" yPosition="below">
	<button class="app-icon app-icon--add-asset" mat-menu-item (click)="addAsset(selectedLocation)"
		*ngIf="selectedLocation">
		<mat-icon /><span>New Asset at This Level</span>
	</button>
	<button class="app-icon app-icon--add-location" mat-menu-item (click)="addLocation(selectedLocation)"
		*ngIf="selectedLocation">
		<mat-icon /><span>New Location at This Level</span>
	</button>
	<button mat-menu-item (click)="toggleHidden()" *ngIf="selectedLocation">
		<mat-icon *ngIf="!selectedLocation.Hidden">visibility_off</mat-icon>
		<mat-icon *ngIf="selectedLocation.Hidden">visibility</mat-icon>
		<span *ngIf="!selectedLocation.Hidden">Hide This Location</span>
		<span *ngIf="selectedLocation.Hidden">Unhide This Location</span>
	</button>
	<button class="app-icon app-icon--delete" mat-menu-item (click)="deleteListLocation(selectedLocation)"
		*ngIf="selectedLocation">
		<mat-icon /><span>Delete This Location</span>
	</button>
</mat-menu>